export default __webpack_public_path__ + "static/media/apple-touch-icon.fda69615.png";